const STUDY_LANGUAGE_COACHMARK_KEY = "study_language_coachmark_dismissed_v1";

export function hasDismissedStudyLanguageCoachmark(): boolean {
  try {
    return localStorage.getItem(STUDY_LANGUAGE_COACHMARK_KEY) === "true";
  } catch {
    return true;
  }
}

export function dismissStudyLanguageCoachmark(): void {
  try {
    localStorage.setItem(STUDY_LANGUAGE_COACHMARK_KEY, "true");
  } catch {
    /* noop */
  }
}

export const STUDY_LANGUAGE_COACHMARK_AUTO_DISMISS_MS = 10_000;
